import React, { useEffect, useState } from "react";
import "./ProfileDetailsForm.css";
import {
  ActionButton,
  Button,
  Container,
  Icon,
  InputDropdown,
  InputField,
  InputPhoneDropdown,
  Notifications,
  Text,
} from "@jds/core";
import {
  emptyObj,
  validateEmail,
  validateNameInput,
  validatePhoneNumber,
  validateTextInput,
} from "../../../util/validation";
import useInput from "../../../hooks/use-input";
import imageUploaded, {
  addParamsURL,
  baseToImg,
  fileToBase,
} from "../../../util/helper";
import useApiHttp from "../../../hooks/use-http";
import PageLoader from "../Loader/PageLoader";
import JdsModal from "../JdsModal";
import AvatarView from "../Views/avatarView/AvatarView";
import AvatarUploadCamera from "./avatarUpload/AvatarUploadCamera";
import { useDispatch, useSelector } from "react-redux";
import decryptUrl from "../../../util/img-decryption";
import { Box, IconButton, Stack, Tooltip } from "@mui/material";
import AdditionalDetailsForm from "./AdditionalDetailsForm";
import Selfie from "../Selfie/Selfie";
import ProfileFormSkeleton from "./ProfileFormSkeleton";
import SelfieLiveliness from "../Selfie/SelfieLiveliness";
import { setSelfieModalClose } from "../../../store/state-slices/userRegistration";

function SecondaryProfileDetailForm(props) {
  const [userSelectProfile, setUserSelectProfile] = useState("");
  const [profileImgModalClose, setrofileImgModalClose] = useState(true);
  const [profileImgModalOpened, setProfileImgModalOpened] = useState(false);
  const [profileImgFile, setProfileImgFile] = useState();
  const [profileHeader, setProfileHeader] = useState("Upload profile picture");
  const profileData = props?.data || null;
  const dispatch = useDispatch()
  const { selfieModalClose } = useSelector((state) => state.userRegistration);

  const { sendRequest: updateProfile, isLoading: isProfileUpdating } =
    useApiHttp();

  const { sendRequest: getFaceCount, isLoading: isGetFaceCounting } =
    useApiHttp();

  const {
    value: profileImage,
    isValid: isValidProfileImage,
    hasError: profileImageError,
    valueChangeHandler: profileImageChangeHandler,
    inputBlurHandler: profileImageBlurHandler,
    reset: resetProfileImage,
  } = useInput(validateTextInput, {
    type: "text",
    value: profileData?.profilePictureThumbnail,
  });

  const {
    value: firstName,
    isValid: isValidFirstName,
    hasError: firstNameError,
    valueChangeHandler: firstNameChangeHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: resetFirstName,
  } = useInput(
    (data) => {
      if (typeof data !== "string") return false;
      if (data.length > 20) return false;
      const pattern = /^[a-zA-Z]+$/; // only letters no numbers, spaces or special chars
      return pattern.test(data.trim());
    },
    {
      type: "text",
      value: profileData?.firstName || "",
    }
  );
  const {
    value: lastName,
    isValid: isValidlastName,
    hasError: lastNameError,
    valueChangeHandler: lastNameChangeHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: resetLastName,
  } = useInput(
    (data) => {
      if (typeof data !== "string") return false;
      if (data.length > 20) return false;
      const pattern = /^[a-zA-Z]+$/; // only letters no numbers, spaces or special chars
      return pattern.test(data.trim());
    },
    {
      type: "text",
      value: profileData?.lastName || "",
    }
  );

  const {
    value: selectedRelation,
    isValid: isSelectedRelationValid,
    hasError: selectedRelationHasError,
    valueChangeHandler: relationChangeHandler,
    inputBlurHandler: relationBlurHandler,
    reset: resetRelationInput,
  } = useInput(validateTextInput, {
    type: "text",
    value: profileData?.relationId,
  });

  const {
    value: emailAddress,
    isValid: isValidEmailAddress,
    hasError: emailAddressError,
    valueChangeHandler: emailAddressChangeHandler,
    inputBlurHandler: emailAddressBlurHandler,
    reset: resetEmailAddress,
  } = useInput(validateEmail, {
    type: "text",
    value: "",
  });

  // const isValidForm =
  //   !isValidFirstName ||
  //   !isValidlastName ||
  //   !isValidEmailAddress ||
  //   !isValidPhoneNumber ||
  //   !isValidProfileImage;

  const isValidForm =
    !isValidFirstName ||
    !isValidlastName ||
    !isSelectedRelationValid ||
    !profileImage;
  // (!isValidEmailAddress ||
  //   emailAddress !== undefined ||
  //   emailAddress !== null);

  const handleSubmit = () => {
    if (profileImgFile) {
      console.log("hello profile");

      const userProfile = new FormData();
      // userProfile.append("email", emailAddress || null);
      if (profileData?.firstName !== firstName) {
        userProfile.append("firstName", firstName.trim());
      }
      if (profileData?.lastName !== lastName) {
        userProfile.append("lastName", lastName.trim());
      }
      if (profileData?.relationId !== selectedRelation) {
        userProfile.append("relationId", selectedRelation);
      }
      userProfile.append("profilePicture", profileImgFile);

      updateProfile(
        {
          base: "AUTH",
          url: profileData
            ? `secondary-profile/${profileData?.id}`
            : "secondary-profile",
          method: profileData ? "PUT" : "POST",
          body: userProfile,
          formData: true,
        },
        null,
        (data) => {
          Notifications.toast.success({
            id: "update-profile",
            title: data?.message,
          });
          console.log("hello1234profile");
          props?.updateProfile({ relationId: selectedRelation });
          props?.closeModal();
        },
        (err, data) => {
          Notifications.toast.error({
            id: "update-profile",
            title: data?.message,
          });
        }
      );
    } else {
      const userProfile = new FormData();
      // userProfile.append("email", emailAddress || null);
      if (profileData?.firstName !== firstName) {
        userProfile.append("firstName", firstName.trim());
      }
      if (profileData?.lastName !== lastName) {
        userProfile.append("lastName", lastName.trim());
      }
      if (profileData?.relationId !== selectedRelation) {
        userProfile.append("relationId", selectedRelation);
      }

      updateProfile(
        {
          base: "AUTH",
          url: profileData
            ? `secondary-profile/${profileData?.id}`
            : "secondary-profile",
          method: profileData ? "PUT" : "POST",
          body: userProfile,
          formData: true,
        },
        null,
        (data) => {
          Notifications.toast.success({
            id: "update-profile",
            title: data?.message,
          });

          props?.updateProfile();
          props?.closeModal();
        },
        (err, data) => {
          Notifications.toast.error({
            id: "update-profile",
            title: data?.message,
          });
        }
      );
    }
    // resetFirstName();
    // resetLastName();
    // resetPhoneNumber();
    // resetEmailAddress();
    // resetProfileImage();
    setUserSelectProfile(null);
    setProfileImgFile(null)
  };

  return (
    <>
      {isProfileUpdating ? (
        <ProfileFormSkeleton />
      ) : (
        <div action="" className="column-form">
          <div style={{ textAlign: "center" }}>
            <Container
              fullWidth
              horizontalAlign="center"
              style={{ marginBottom: "12px" }}
            >
              <Text text="Upload Image *" color="primary-grey-80" />
            </Container>
            <AvatarView
              image={
                userSelectProfile
                  ? baseToImg(userSelectProfile)
                  : addParamsURL(profileData?.profilePictureThumbnail, {
                    size: "m",
                  })
                    ? // ? decryptUrl(profileData?.profilePictureThumbnail)
                    addParamsURL(profileData?.profilePictureThumbnail, {
                      size: "m",
                    })
                    : ""
              }
              avatarKind={isProfileUpdating ? "icon" : "image"}
              onClick={() => {
                dispatch(setSelfieModalClose(false));
              }}
            />
            {profileImgModalOpened && !profileImage && (
              <>
                {" "}
                <Container
                  fullWidth
                  horizontalAlign="center"
                  verticalAlign="center"
                  style={{ marginTop: "12px", gap: "8px" }}
                >
                  <Icon ic={"IcErrorColored"} size={"small"} />
                  <Text
                    text="Please upload a valid image!"
                    color="feedback-error-80"
                    appearance="body-xs"
                  />
                </Container>
              </>
            )}
          </div>

          {profileData?.userType === "SCHOOL" ? (
            <JdsModal
              header={profileHeader}
              size="m"
              close={profileImgModalClose}
              onClose={() => {
                setrofileImgModalClose(true);
                setProfileImgModalOpened(true);
              }}
            >
              {!profileImgModalClose && (
                <AvatarUploadCamera
                  image={
                    userSelectProfile
                      ? baseToImg(userSelectProfile)
                      : profileData?.profilePictureThumbnail
                        ? // ? decryptUrl(profileData?.profilePictureThumbnail)
                        addParamsURL(profileData?.profilePictureThumbnail, {
                          size: "m",
                        })
                        : ""
                  }
                  accept=".png ,.jpg ,.jpeg"
                  fileValue={(file) => {
                    setProfileImgFile(file);
                    fileToBase(file)
                      .then((base64Value) => {
                        setUserSelectProfile(base64Value);
                        profileImageChangeHandler({
                          target: { value: base64Value },
                        });
                      })
                      .catch((error) => { });
                  }}
                  setProfileHeader={(e) => setProfileHeader(e)}
                />
              )}
            </JdsModal>
          ) : (
            <JdsModal
              kind={"custom"}
              header="Profile picture"
              headerProps={{
                divider: "false",
              }}
              size="m"
              close={selfieModalClose}
              onClose={() => {
                dispatch(setSelfieModalClose(true));
                setProfileImgModalOpened(true);
              }}
            >
              {!selfieModalClose &&
                <SelfieLiveliness
                  isGetFile={true}
                  getFile={(file) => {
                    setProfileImgFile(file);
                    fileToBase(file)
                      .then((base64Value) => {
                        setUserSelectProfile(base64Value);
                        profileImageChangeHandler({
                          target: { value: base64Value },
                        });
                      })
                      .catch((error) => { });
                    dispatch(setSelfieModalClose(true));
                    setProfileImgModalOpened(true);
                  }}
                />}
              {/* <Selfie
                  isGetFile={true}
                  getFile={(file) => {
                    setProfileImgFile(file);
                    fileToBase(file)
                      .then((base64Value) => {
                        setUserSelectProfile(base64Value);
                        profileImageChangeHandler({
                          target: { value: base64Value },
                        });
                      })
                      .catch((error) => { });
                    setrofileImgModalClose(true);
                    setProfileImgModalOpened(true);
                  }}
                /> */}
            </JdsModal>
          )}

          <InputField
            label="First Name *"
            value={firstName}
            name="firstName"
            onChange={(e) => {
              firstNameChangeHandler(e, e.target.value);
            }}
            onBlur={firstNameBlurHandler}
            state={firstNameError ? "error" : ""}
            stateText={
              firstName?.length > 20
                ? "The First name length can't exceed 20 characters"
                : firstName?.length == 0
                  ? "The First name can't be blank"
                  : "The First name can't contain spaces, special characters and numbers"
            }
          />
          <InputField
            label="Last Name *"
            value={lastName}
            name="lastName"
            onChange={(e) => {
              lastNameChangeHandler(e, e.target.value);
            }}
            onBlur={lastNameBlurHandler}
            state={lastNameError ? "error" : ""}
            stateText={
              lastName?.length > 20
                ? "The Last name length can't exceed 20 characters"
                : lastName?.length == 0
                  ? "The Last name can't be blank"
                  : "The Last name can't contain spaces, special characters and numbers"
            }
          />

          <Box>
            {profileData?.relationName && (
              <Stack direction="row" alignItems="center" gap={"6px"} my={2}>
                <Text text="Current Relationship :" color="primary-grey-80" />
                <Text text={profileData?.relationName} />
              </Stack>
            )}
            {props?.availableRelationList.length > 0 && (
              <InputDropdown
                label={`${props?.isAddForm ? "Select" : "Change"} Relationship`}
                value={selectedRelation}
                items={props?.availableRelationList?.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                })}
                onSelect={(index, value) => {
                  relationChangeHandler({ target: { value: value } });
                }}
                required
              />
            )}
          </Box>

          <Container
            fullWidth
            horizontalAlign={"center"}
            style={{
              marginTop: "24px",
              margin: "auto",
              width: props?.isDeletable ? "100%" : "200px",
            }}
            gap={8}
          >
            <Button
              disabled={isValidForm}
              type="submit"
              fullWidth
              label={isProfileUpdating ? "Saving" : "Save"}
              size="large"
              onClick={() => {
                handleSubmit();
              }}
              loading={isProfileUpdating}
            />
            {props?.isDeletable && (
              <Button
                fullWidth
                label={"Delete"}
                kind="primary"
                size="large"
                onClick={() => {
                  props?.onDeleteClick(profileData);
                }}
                state="destructive"
              />
            )}
          </Container>
        </div>
      )}
      {isProfileUpdating ||
        (isGetFaceCounting && (
          <PageLoader open={isProfileUpdating || isGetFaceCounting} />
        ))}
    </>
  );
}

export default React.memo(SecondaryProfileDetailForm);
